import React from "react";
import { TextField } from '@material-ui/core';
import { useField , useFormikContext} from "formik";

const TextfieldEnLettersWrapper = ({
    name,
    ...otherProps
}) => {

    const { setFieldValue } = useFormikContext();
    const [field, mata] = useField(name);

    const handleChange = e => {
        const input = e.currentTarget.value;
        if (/^[a-zA-Z- ]+$/.test(input) || input === "") {
            setFieldValue(name, input);
        }
    };

    const configTextfieldEnLetters = {
        ...field,
        ...otherProps,
        fullWidth: true,
        variant: 'outlined',
        onChange: handleChange
    }

    if (mata && mata.touched && mata.error) {
        configTextfieldEnLetters.error = true;
        configTextfieldEnLetters.helperText = mata.error;
    }
    return (
        <TextField {...configTextfieldEnLetters} />
    );
};

export default TextfieldEnLettersWrapper;
